import { PartnersMap } from "@beholos/holoscommon";
import { useEffect } from "react";
import { usePageTitle } from '../../hooks/usePageTitle';

export default function Partners() {
  usePageTitle('Partners - Holos');
  useEffect(() => {
    // Prevent body scroll when this component mounts
    document.body.style.overflow = 'hidden';
    
    return () => {
      // Restore body scroll when component unmounts
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="h-[calc(100vh-90px)] w-full overflow-hidden">
      <PartnersMap />
    </div>
  )
}